<template>
	<b-form @submit.stop.prevent="save($event); return false">
		<b-form-row>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<b-form-row class="mb-3">
						<b-col><b-form-checkbox v-model="settings.showEmojis">Show emojis</b-form-checkbox></b-col>
						<b-col class="text-center"><b-form-checkbox v-model="settings.physics">Physics simulation</b-form-checkbox></b-col>
						<b-col class="text-right"><b-form-checkbox v-model="settings.physicsHulls" :disabled="!settings.physics">Precise shapes</b-form-checkbox></b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Duration" append="seconds">
								<b-input-group :append="`${settings.duration} seconds`">
									<b-input type="range" v-model="settings.duration" min="1" max="120"></b-input>
								</b-input-group>
							</b-form-group>
							<b-form-group label="Emote and emoji size">
								<b-input type="range" v-model="settings.emoteSize" min="1" max="20"></b-input>
							</b-form-group>
							<b-form-group label="Sticker and gift size">
								<b-input type="range" v-model="settings.stickerSize" min="1" max="40"></b-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Gravity" append="seconds" :disabled="!settings.physics">
								<b-input-group append="N">
									<b-input v-model="settings.gravity" min="0" max="100" step="any"></b-input>
								</b-input-group>
							</b-form-group>
							<b-form-group label="Extra shapes" description="Input one convex fixed collision shape per line, in the format X1,Y1 X2,Y2 ..." :disabled="!settings.physics">
								<b-textarea v-model="settings.shapes"></b-textarea>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="In Transition">
								<b-form-select v-model="settings.inTransition" :options="inTransitions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Out Transition">
								<b-form-select v-model="settings.outTransition" :options="outTransitions"></b-form-select>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<preview class="mb-3" slug="emoteWall" name="Emote Wall" />
			</b-col>
		</b-form-row>
		<b-card class="text-center mb-3">
			<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
			<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
				<b-button variant="primary" type="submit">Save settings</b-button>
			</b-overlay>
		</b-card>
	</b-form>
</template>

<script>
import animateCssTransitions from '../../animateCssTransitions';
import Preview from '@/components/Widget/Preview.vue';

export default {
	data() { return {
		settings: {},
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		inTransitions: [ ...[{ text: 'No transition', value: null }], ...animateCssTransitions.inTransitions ],
		outTransitions: [ ...[{ text: 'No transition', value: null }], ...animateCssTransitions.outTransitions ],
	}; },
	components: {
		Preview,
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			const settings = await this.$api.get('widgetSettings/emote-wall');
			this.settings = {
				...settings,
				physics: !!settings.physics,
				physicsHulls: !!settings.physicsHulls,
				showEmojis: !!settings.showEmojis,
				duration: settings.duration || 15,
				emoteSize: settings.emoteSize || 5,
				stickerSize: settings.stickerSize || 5,
				inTransition: settings.inTransition||null,
				outTransition: settings.outTransition||null,
			};
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async save() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('widgetSettings/emote-wall', this.settings);
			} catch(e) {
				console.error('Error saving widget:', e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
